import { gql } from '@apollo/client';

const rejectShareObjectMutation = (shareUri: string, reason?: string) => {
    return {
        variables: {
            shareUri,
            reason: reason || '',
        },
        mutation: gql`
            mutation RejectShareObject($shareUri: String!, $reason: String!) {
                rejectShareObject(shareUri: $shareUri, reason: $reason) {
                    shareUri
                    status
                }
            }
        `,
    };
};

export default rejectShareObjectMutation;
